import CarbonClient from "../CarbonClient";

const getLifetimeTable = async () => {
  const response = await CarbonClient.get("api/Mapping/lifetimetable");
  if (response.status === 200) {
    return response.data;
  } else {
    return response;
  }
};

export default getLifetimeTable;
